import { AloBase } from '@/models/alo/AloBase';
import { StateItem, buildStateItem } from '@/models/alo/StateItem';


export interface IUiState {   
    contentHeight:number
    rightDrawerOpen:boolean
    rightDrawerEnable:boolean
    snackMessages:  Array<string>
    showAllergene:boolean
    showCart:boolean

    searchSejour:string
    sortSejourDesc:boolean
    sortSejourBy:string	

    searchUser:string
    sortUserDesc:boolean
    sortUserBy:string	

    searchCommande:string
    sortCommandeDesc:boolean
    sortCommandeBy:string	

    searchMailTemplate:string
    sortMailTemplateDesc:boolean
    sortMailTemplateBy:string	

    searchMailSkin:string
    sortMailSkinDesc:boolean
    sortMailSkinBy:string

    printMode:boolean

}

//Initial State
const state: IUiState = {      
    contentHeight:250,
    rightDrawerOpen:false,
    rightDrawerEnable:false,
    snackMessages: [],
    showAllergene:false,
    showCart:false,

    searchSejour:"",
    sortSejourDesc:false,
    sortSejourBy:"",

    searchUser:"",
    sortUserDesc:false,
    sortUserBy:"",

    searchCommande:"",
    sortCommandeDesc:false,
    sortCommandeBy:"",

    searchMailTemplate:"",
    sortMailTemplateDesc:false,
    sortMailTemplateBy:"",

    searchMailSkin:"",
    sortMailSkinDesc:false,
    sortMailSkinBy:"",

    printMode:false,
    
} 

export default state